import { render, staticRenderFns } from "./EditorTextarea.vue?vue&type=template&id=3184bc10&"
import script from "./EditorTextarea.vue?vue&type=script&lang=js&"
export * from "./EditorTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports